export class ManageProfileCommon {
public static employeeFormErrors = {
'firstName': '',
'middleName': '',
'lastName': '',
'dateOfBirth':'',
'bloodGroup': '',
'panNumber': '',
'aadharNumber': '',
'qualification': '',
'certification': '',
'gender':'',
'profileStatus': '',
'loginAccess': '',
'email':'',
'personalEmail':'',
'officalMobileNumber':'',
'contactMobileNumber':'',
'landlineStdCode':'',
'landlineNumber':'',
'emergencyContactNumber1':'',
'emergencyContactName1':'',
'emergencyContactRelation1':'',
'emergencyContactNumber2':'',
'emergencyContactName2':'',
'emergencyContactRelation2':'',
'address':'',
'city':'',
'state':'',
'postalCode':'',
'country':'',     
   
'branch':'',
'role':'',
'designation':'',
'reportingManager':'',    
'reportingPartner':'',    
'joiningDate':'',
'membershipNumber':'',  
'probabtionPeriod':'',  
'articleTrainingLimit':'',    
'isVerified':'',  
'confirmationDate':'',  
'verificationSource':'',    
'remark':'',     
'laptopServiceTagNumber':'',    
'dataCardNumber':'',     
'bankAcountName':'',    
'bankAccountNumber':'',     
'icaiRegistrationDate':'',   
'icaiRegistrationNumber':'',    
'articleshipEndDate':'',     
'registeredPartner':'',  

'basic':'',     
'hra':'',   
// mobileAllowance:'',  
'otherAllowance':'',      
'conveyanceAllowance':'',    
'medicalAllowance':'', 
'educationAllowance':'',     
'childHostelAllowance':'',    
'fromDate':'',      
'toDate':'', 
};

public static employeeFormValidationMessages = {
'firstName': {
'required': 'first name is required.',
'minlength': 'first name is minlength 50.',
'maxlength': 'first name is maxlength 50',
},
'middleName': {
'required': 'middle name is required.',
'minlength': 'middle name is minlength 50.',
'maxlength': 'middle name is maxlength 50',
},
'lastName': {
'required': 'last name is required.',
'minlength': 'last name is minlength 50.',
'maxlength': 'last name is maxlength 50',
},
'dateOfBirth': {
'required': 'date of birth is required.',
'ngbDate':''
},
'bloodGroup': { 'required': 'blood group is required.'},
'panNumber': { 'required': 'pan number is required.'},
'aadharNumber': { 'required': 'aadhar number is required.'},
'qualification': { 'required': 'qualification is required.'},
'certification': { 'required': 'certification is required.'},
'gender': { 'required': 'gender is required.'},
'profileStatus': { 'required': 'profile status is required.'},
'loginAccess': { 'required': 'login access is required.'},
'email': { 'required': 'official email is required.'},
'personalEmail': { 'required': 'personal email is required.'},
'officalMobileNumber':{ 'required': 'official mobile no is required.'},
'contactMobileNumber': { 'required': 'personal mobile no is required.'},
'landlineStdCode':{ 'required': 'std code is required.'},
'landlineNumber': { 'required': 'landline no is required.'},
'emergencyContactNumber1':{ 'required': 'emergency contact no is required.'},
'emergencyContactName1':{ 'required': 'emergency contact name is required.'},
'emergencyContactRelation1': { 'required': 'emergency contact realtion is required.'},
'emergencyContactNumber2': {'required': 'emergency contact no is required.'},
'emergencyContactName2': {'required': 'emergency contact name is required.'},
'emergencyContactRelation2': { 'required': 'emergency contact realtion is required.'},
'address': { 'required': 'address is required.'},
'city':{ 'required': 'city is required.'},
'state':{ 'required': 'state is required.'},
'postalCode':{ 'required': 'pincode is required.'},
'country':{ 'required': 'country is required.'},   

'branch':'',
'role':'',
'designation':'',
'reportingManager':'',    
'reportingPartner':'',    
'joiningDate':'',
'membershipNumber':'',  
'probabtionPeriod':'',  
'articleTrainingLimit':'',    
'isVerified':'',  
'confirmationDate':'',  
'verificationSource':'',    
'remark':'',     
'laptopServiceTagNumber':'',    
'dataCardNumber':'',     
'bankAcountName':'',    
'bankAccountNumber':'',     
'icaiRegistrationDate':'',   
'icaiRegistrationNumber':'',    
'articleshipEndDate':'',     
'registeredPartner':'',

'basic':'',     
'hra':'',   
// mobileAllowance:'',  
'otherAllowance':'',      
'conveyanceAllowance':'',    
'medicalAllowance':'', 
'educationAllowance':'',     
'childHostelAllowance':'',    
'fromDate':'',      
'toDate':'', 

};
}


